module.exports = "/assets/91efb583f301863b3ee897de10f33130.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/Y7.png
// module id = 2020
// module chunks = 0